// extracted by mini-css-extract-plugin
export default {"menubar":"styles_menubar__Q0SCA","menu":"styles_menu__lPv7j","active":"styles_active__+nt92"};